import {createSelector} from 'reselect';
import {RootState} from 'typesafe-actions';

import {SystemState} from './reducer';
import ISystemInfo = MyTypes.ISystemInfo;

export const systemSelector = (state: RootState): SystemState => state.system;

export const getSystemLoaded = createSelector<any, any, boolean>(
  systemSelector,
  (state: SystemState) => state.loaded
);

export const getSystemInfo = createSelector<any, any, ISystemInfo>(
  systemSelector,
  (state: SystemState) => state.info
);



// WEBPACK FOOTER //
// ./src/store/system/selectors.ts